import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import {
  HeaderWrapper,
} from './styles';

const PlaceholderWrapper = styled.div`
  padding: 0 40px 60px 40px;
`;

const PlaceholderVersion = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: center;
  margin-top: 30px;
`;

const PlaceholderChip = styled.div`
  margin-right: 11px;
  padding: 6px 10px;
  height: 26px;
  border-radius: 13px;
  line-height: 14px;
  width: 56px;
  background-color: ${(props) => props.isMajor ? props.theme['color.primary'] : props.theme['placeholder.bg.color']};
  opacity: 0.3;
`;

const PlaceholderText = styled.div`
  height: ${(props) => props.height}px;
  max-width: ${(props) => props.maxWidth}px;
  border-radius: ${(props) => (props.height / 2)}px;
  background-color: ${(props) => props.isMajor ? props.theme['color.primary'] : props.theme['placeholder.bg.color']};
  opacity: 0.3;
  flex: 1;
  margin-left: ${(props) => props.indent ? `${props.indent}px` : 0};
  margin-top: 15px;
`;

const PlaceholderVersionText = styled(PlaceholderText)`
  margin-right: 11px;
  margin-top: 0px;
`;

const PlaceholderRow = ({ isMajor }) => (
  <Fragment>
    <HeaderWrapper>
      <PlaceholderVersion>
        <PlaceholderChip isMajor={isMajor} />
        {isMajor && <PlaceholderVersionText height={14} maxWidth={103} isMajor={isMajor} />}
      </PlaceholderVersion>
      <PlaceholderText height={14} maxWidth={72} />
    </HeaderWrapper>
    <PlaceholderText height={24} />
    <PlaceholderText height={24} maxWidth={350} indent={25} />
    <PlaceholderText height={24} maxWidth={250} indent={25} />
    <PlaceholderText height={24} maxWidth={300} indent={25} />
  </Fragment>
);

PlaceholderRow.propTypes = {
  isMajor: PropTypes.bool,
};

const PlaceholderList = () => (
  <PlaceholderWrapper>
    <PlaceholderRow />
    <PlaceholderRow />
    <PlaceholderRow isMajor />
  </PlaceholderWrapper>
);

export default PlaceholderList;
